// line_item
export const LINE_ITEM_OPTION = 'line_item_option'
export const OPTION_EXISTING_LINE_ITEM = 'option_existing_line_item'
export const OPTION_NEW_LINE_ITEM = 'option_new_line_item'
export const LINE_ITEM = 'line_item'

// budget
export const BUDGET_LIFETIME = 'budget_lifetime'
